var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxIndeterminateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_160732",
    "data-name": "Group 160732",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    "data-name": "Group 1386"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    width: 15,
    height: 15,
    rx: 4,
    fill: "#1450ff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385",
    transform: "translate(1.875 2.5) scale(0.8)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "indeterminate",
    x1: 2,
    y1: 6,
    x2: 12,
    y2: 6,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 15,
    height: 15,
    transform: "translate(0.125 0.5)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIndeterminateIcon);
export default __webpack_public_path__ + "static/media/checkbox-indeterminate-icon.1149807ca0b0351fb38f0026e3d1d915.svg";
export { ForwardRef as ReactComponent };